<template>
  <div class="coupon" :class="{ home: itemType === 'home' }">
    <div class="price">{{ priceText }}</div>
    <div class="detail">
      <p class="name">{{ name }}</p>
      <countDown
        :start="useStartTime"
        :end="expiryDate"
        :server="server"
        ref="countDown"
        @update="onUpdate"
      >
        <p class="valid-date" slot-scope="scope">
          还剩<span class="days">{{ scope.days }}</span
          >天<span class="hours">{{ scope.hours }}</span
          >:<span>{{ scope.minutes }}</span
          >:<span>{{ scope.seconds }}</span>
        </p>
      </countDown>
    </div>
    <div v-if="itemType === 'home'" class="btn-use" @click="$emit('toUse')">
      去使用
    </div>
  </div>
</template>
<script>
import countDown from './countDown'

export default {
  props: {
    itemType: {
      type: String,
      default: 'item'
    },
    useStartTime: {
      type: String,
      default: ''
    },
    expiryDate: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    price: {
      type: Number || String,
      default: ''
    },
    type: {
      type: String,
      default: 'price'
    },
    discount: {
      type: String,
      default: ''
    }
  },
  components: {
    countDown
  },
  computed: {
    priceText() {
      if (this.type === 'Cash') {
        return `￥${this.price}`
      }
      if (this.type === 'Discount') {
        return `${this.discount / 10}折`
      }
      if (this.type === 'Free') {
        return '免单'
      }
      return ''
    }
  },
  data() {
    return {
      server: Date.now()
    }
  },
  mounted() {
    this.$refs.countDown.countDown()
  },
  methods: {
    onUpdate(server) {
      this.server = server
    }
  }
}
</script>
<style lang="scss" scoped>
.coupon {
  position: relative;
  width: 514px;
  height: 154px;
  margin: 0 auto 14px;
  background: url('~images/qingsu/channel/coupon-item.png') no-repeat
    center/100%;
  @include flex(row, flex-start, center);
  &.home {
    width: 690px;
    background: url('~images/qingsu/channel/coupon.png') no-repeat center/100%;
    margin-bottom: 60px;
  }
  .price {
    min-width: 140px;
    text-align: center;
    font-size: 48px;
    font-weight: 500;
    color: #fff;
    line-height: 67px;
    padding-left: 10px;
  }
  .detail {
    height: 100%;
    margin-left: 38px;
    @include flex(column, center, flex-start);
  }
  .name {
    font-size: 28px;
    font-weight: 600;
    color: #ff745b;
    line-height: 40px;
    margin-bottom: 6px;
  }
  .valid-date {
    font-size: 22px;
    color: #ff745b;
    line-height: 30px;
    @include flex(row, center, center);
    span {
      width: 36px;
      height: 38px;
      background: #ff745b linear-gradient(180deg, #fecec6 0%, #fc7052 100%);
      border-radius: 8px;
      margin: 0 6px;
      font-size: 20px;
      font-weight: 600;
      color: #fff;
      @include flex(row, center, center);
      &.days {
        margin: 0 10px;
      }
      &.hours {
        margin: 0 6px 0 10px;
      }
    }
  }
  .btn-use {
    @include flex(row, center, center);
    position: absolute;
    right: 30px;
    top: 52px;
    width: 130px;
    height: 50px;
    background: #ffa202;
    border-radius: 32px;
    font-size: 24px;
    color: #ffffff;
  }
}
</style>
